import { ComponentConfig } from "@measured/puck"
import "ckeditor5/ckeditor5.css"
import CKEditorComponent from "../../../../../lib/Ckeditor"
import { commonStylesProps } from "../../lib/commonCSSProps"
import { RenderConfig, TextProps } from "./RenderConfig"

export const Text: ComponentConfig<TextProps> = {
  // @ts-ignore
  fields: {
    text: {
      label: "Text",
      type: "custom",
      render: ({ value, onChange }) => {
        return <CKEditorComponent value={value} onChange={onChange} />
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    text: "Default text",
    className: "",
    styles: {
      mobile: { display: "block" },
      tablet: { display: "block" },
      desktop: { display: "block" },
    },
  },
  ...RenderConfig,
}
